import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { legacyTheme } from '@prose-ui/legacy';
import { makeStyles } from 'legacyStyles';

import AutoPlayVideo from 'Components/AutoPlayVideo';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

const useStyles = makeStyles({
  root: {
    width: '100vw',
    height: `56vw`,
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    overflow: 'hidden',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    [legacyTheme.breakpoints.match('sm')]: {
      height: '125vw',
    },
  },
  heroVideo: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 'auto',
    width: '100%',
    zIndex: '-100',
  },
  heroBlock: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
  },
});

const HeroVideo = forwardRef(
  ({ children, imageDesktop, imageMobile, videoDesktop, videoMobile, ...props }, ref) => {
    // style override through classes prop
    const { classes } = useStyles(undefined, props?.classes ? { props } : undefined);

    return (
      <div ref={ref} className={classes.root}>
        <AutoPlayVideo
          className={classes.heroVideo}
          desktopImage={imageDesktop}
          desktopVideo={videoDesktop}
          mobileImage={imageMobile}
          mobileVideo={videoMobile}
        />
        <div className={classes.heroBlock}>{children}</div>
      </div>
    );
  }
);
HeroVideo.displayName = 'HeroVideo';

HeroVideo.defaultProps = { classes: null };

HeroVideo.propTypes = {
  children: PropTypes.node.isRequired,
  /** For style overriding purposes */
  classes: PropTypes.objectOf(PropTypes.string),
  imageDesktop: srcOrNextImageProp.isRequired,
  imageMobile: srcOrNextImageProp.isRequired,
  videoDesktop: PropTypes.string.isRequired,
  videoMobile: PropTypes.string.isRequired,
};

export default HeroVideo;
